export const unitCardSectionConfig = {
  currencyCode: '$',
};
